import { useRef, useState } from 'react'
import useWindowSize from 'react-use/lib/useWindowSize'

import {
  Modal,
  ModalProps,
  Text,
  Stack,
  Button,
  Card,
  Heading,
  Icon,
  IconButton,
  Divider,
  useToast,
  Box,
} from '@thirstycamel/ui'

import { useActions, useStore } from '../../store/hooks'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import { MyOffersSingleOfferResponse } from '@thirsty-camel/hump-club/src/modules/offer/offer.object'
import AvailableOffer from '../AvailableOffer'
import { OfferEntity } from '@thirsty-camel/hump-club/src/modules/offer/offer.entity'
import { getNiceErrorMessage } from '../../utils/getNiceErrorMessage'

dayjs.extend(relativeTime)

const ModalViewOfferTerms: React.FC<ModalProps & { offer: OfferEntity }> = ({
  isVisible,
  onClose,
  offer,
}) => {
  return (
    <Modal onClose={onClose} isVisible={isVisible} heading={`${offer?.name} Terms & Conditions`}>
      <Stack py={2} spacing={5}>
        {offer?.termsAndConditions && <Text fontSize="xs">{offer?.termsAndConditions}</Text>}
        <Button
          variantColor="pink"
          onClick={() => {
            onClose()
          }}
          flexShrink={0}
        >
          Close
        </Button>
      </Stack>
    </Modal>
  )
}

export default ModalViewOfferTerms
